<template>
  <v-card 
    outlined 
    elevation="2" 
    :loading="loading" 
    :class="{ 'card-height': loading }"
  >
    <v-card-title class="justify-center">
      <p class="text-sm-h5 text-md-h4 font-weight-bold primary--text mt-2">
        {{ title }}
      </p>
    </v-card-title>
    <template v-if="!loading">
      <v-card-text>
        <slot></slot>
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
export default {
  props: {
    title: String,
    loading: Boolean,
  }
};
</script>

<style scoped>
.card-height {
  height: 100vh;
}
</style>